import React, {useEffect, useState} from 'react';
import {NavLink, useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import InspectionForm from '../../SVG/InspectionForm';
import './styles.scss';
import { toast } from 'react-toastify';
import ROUTES from '../../utils/routes';
import { setSidebar } from '../../store/builder/inspectionSlice';
import { useTranslation } from '../../hooks/useTranslation';

const SideCustomInspectionsDropdown = ({
  showOld,
  custom_inspections_disabled,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState(false);
  const fboDropDown = localStorage.getItem('navbarDropDown');
  const sidebarStatus = useSelector(
    state => state?.rootReducer?.inspectionSlice?.sidebar,
  );

  useEffect(() => {
    setDropdown(sidebarStatus);
    localStorage.setItem('navbarDropDown', sidebarStatus ? 'true' : 'false');
  }, [sidebarStatus]);

  const handleOnClick = () => {
    if (!sidebarStatus) { 
      dispatch(setSidebar(true));
      localStorage.setItem('sidebar-status', true);
    }

    if (sidebarStatus) {
      setDropdown(!dropdown);
      localStorage.setItem(
        'navbarDropDown',
        fboDropDown === 'false' ? 'true' : 'false',
      );
    }
  };

  const handleRedirect = (url, state) => {
    if (custom_inspections_disabled) {
      toast.warning(t('dropdown.noAccess'));
      navigate(ROUTES.public.accessDenied, {state});
    } else {
      navigate(url, {state});
    }
  };

  return (
    <div className={`sidebar__link initial column`}>
      <div
        onClick={handleOnClick}
        className={`sidebar__link-inner column ${
          (
            showOld
              ? location.pathname === '/custom-inspections' ||
                location.pathname === '/forms' ||
                location.pathname === '/inspection-form'
              : location.pathname === '/corporate/custom-inspections' ||
                location.pathname === '/corporate/forms'
          )
            ? 'active'
            : ''
        }`}
      >
        <InspectionForm
          color={
            location.pathname === '/custom-inspections' ? '#FFFFFF' : '#AEB3B7'
          }
        />
        <p className='sidebar__link-name'>{t('dropdown.manageCustomInspections')}</p>
      </div>
      {fboDropDown === 'true' && (
        <div className='sidebar__dropdown'>
          {!showOld ? (
            <>
              <div
                className={`sidebar__dropdown-elem ${location?.pathname === '/corporate/custom-inspections' ? 'active' : ''}`}
                onClick={() =>
                  handleRedirect(
                    custom_inspections_disabled
                      ? ROUTES.public.accessDenied
                      : '/corporate/custom-inspections',
                    {userType: 'corporate'},
                  )
                }
              >
                {t('dropdown.customInspections')}
              </div>
              <div
                className={`sidebar__dropdown-elem ${location.pathname === '/corporate/forms' ? 'active' : ''}`}
                onClick={() =>
                  handleRedirect(
                    custom_inspections_disabled
                      ? ROUTES.public.accessDenied
                      : '/corporate/forms',
                    {userType: 'corporate'},
                  )
                }
              >
                {t('dropdown.forms')}
              </div>
            </>
          ) : (
            <>
              <div
                className={`sidebar__dropdown-elem ${location.pathname === '/custom-inspections' ? 'active' : ''}`}
                onClick={() =>
                  handleRedirect(
                    custom_inspections_disabled
                      ? ROUTES.public.accessDenied
                      : '/custom-inspections',
                  )
                }
              >
                {t('dropdown.customInspections')}
              </div>
              <div
                className={`sidebar__dropdown-elem ${location.pathname === '/forms' ? 'active' : ''}`}
                onClick={() =>
                  handleRedirect(
                    custom_inspections_disabled ? ROUTES.public.accessDenied : '/forms',
                  )
                }
              >
                {t('dropdown.forms')}
              </div>
            </>
          )}
          {showOld && (
            <>
              <NavLink
              className={`sidebar__dropdown-elem ${location.pathname === '/inspection-form' ? 'active' : ''}`}
              to='/inspection-form'
            >
              {t('dropdown.oldCustomInspections')}
            </NavLink>
            <NavLink
              className={`sidebar__dropdown-elem ${location.pathname === ROUTES.private.customEquipmentType ? 'active' : ''}`}
              to={ROUTES.private.customEquipmentType}
            >
              {t('dropdown.customEquipmentType')}
            </NavLink>
            </>
          )}
          <img
            className='sidebar__icon one'
            src='/assets/icons/dropdown-short.svg'
            alt='icon'
          />
          <img
            className='sidebar__icon two'
            src='/assets/icons/dropdown-long.svg'
            alt='icon'
          />
          {showOld && (
            <>
              <img
              className='sidebar__icon three'
              src='/assets/icons/dropdown-long.svg'
              alt='icon'
              />
              <img
              className='sidebar__icon five'
              src='/assets/icons/dropdown-long.svg'
              alt='icon'
            />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SideCustomInspectionsDropdown;
